export const getTitlingReviewDogProps = (route: any) => ({
  propsDogId: route.query.dogId,
});

export const getMyPedigreesProps = (route: any) => ({
  dogId: route.params.dogId,
});
